<template>
    <div class="page-loader">
        <common-icon v-if="isLoading" class="page-loader__loader" name="loader" size="extra-larger"></common-icon>
        <div :class="loaderClass">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            isLoading: { type: Boolean, required: false },
        },

        computed: {
            loaderClass() {
                return {
                    'page-loader__active': this.isLoading,
                }
            },
        },
    }
</script>
